import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { dispatch_theme } from '@/config/colors';
import { i18next } from '@/config/i18n';
import { useInteractiveRollkarteFlag } from '@/hooks/useInteractiveRollkarteFlag';
import Export from './Export';

const useStyles = makeStyles((theme: typeof dispatch_theme) => ({
  dialogTitle: {
    background: 'rgba(239, 89, 39, 0.12)',
  },
  dialogContent: {
    padding: '0px',
  },
  closeIconBtn: {
    position: 'absolute',
    right: 12,
    top: 8,
    padding: 4,
  },
}));

interface ExportDialogProps {
  open: boolean;
  onClose: () => void;
  routes: any[];
  title?: string;
}

export const ExportDialog: React.FC<ExportDialogProps> = ({
  open,
  onClose,
  routes,
  title,
}) => {
  const classes = useStyles();
  const { enabled: interactiveRollkarte } = useInteractiveRollkarteFlag();

  const content = (
    <Dialog open={open} fullWidth={true} maxWidth={'lg'} onClose={onClose}>
      <DialogTitle className={classes.dialogTitle}>
        {title || i18next.t('common:buttons.tourExport')}
        <IconButton
          aria-label="close"
          onClick={onClose}
          className={classes.closeIconBtn}
        >
          <CloseOutlined style={{ color: '#000000' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Export routes={routes} interactiveRollkarte={interactiveRollkarte} />
      </DialogContent>
    </Dialog>
  );

  // Wrap with DndProvider only when the feature flag is enabled
  if (interactiveRollkarte) {
    return <DndProvider backend={HTML5Backend}>{content}</DndProvider>;
  }

  return content;
};
